import { Injectable } from '@angular/core';
import { environment } from '../../../../enviroments/enviroment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemResponse } from '../models/SystemsModel';

@Injectable({
  providedIn: 'root',
})
export class SystemsService {
  systemsDataEndpoint: string = `${environment.urlEndPoint}/api/sistemas/all`;
  constructor(private http: HttpClient) {}
  fetchSystemsData(): Observable<SystemResponse[]> {
    return this.http.get<SystemResponse[]>(this.systemsDataEndpoint);
  }
}
